import { request } from '../apis';

export interface HrManagerSetting {
  email: string | null;
  employeeName: string | null;
  updatedAt: string | null;
  updatedByUpn: string | null;
}

export interface UpdateHrManagerResult {
  setting: HrManagerSetting;
  previousEmail: string | null;
}

export const HrManagerService = {
  get: () => request.get<HrManagerSetting>('hr-manager'),

  update: (email: string) =>
    request.put<UpdateHrManagerResult>('hr-manager', { email })
};
